// Configuration object that prioritizes environment variables
const Configs = {
  // Core Parse Server Configuration
  parseServerURL: process.env.REACT_APP_PARSE_SERVER_URL,
  parseInitialize: process.env.REACT_APP_PARSE_INITIALIZE,
  serverUrl: process.env.REACT_APP_SERVER_URL,

  // Parse Reports Configuration
  parseReportsServerURL: process.env.REACT_APP_PARSE_REPORT_SERVER_URL,
  parseReportsApplicationId: process.env.REACT_APP_PARSE_REPORT_APPLICATION_ID,

  // Security & Authentication
  adminToken: process.env.REACT_APP_ADMIN_TOKEN,

  // License
  licensePivot: process.env.REACT_APP_LICENSE_PIVOT,

  // External Services
  foodZaps: process.env.REACT_APP_FOODZAPS,
  backendUrl: process.env.REACT_APP_BACKEND_URL,
  openAPIUrl: process.env.REACT_APP_OPEN_API_URL,
  eberUrl: process.env.REACT_APP_EBER_URL,
  abossUrl: process.env.REACT_APP_ABOSS_URL || "https://aboss.foodzaps.com",

  // Storage & CDN
  s3Url: process.env.REACT_APP_S3_URL,
};

export default Configs;
